src = "https://code.jquery.com/jquery-3.6.0.min.js";
const freeChoiceIds = [];
let resultFreeChoice = [];
var $jq = jQuery.noConflict();
$jq(".quanti[data-id]").each((t, e) => {
    freeChoiceIds.push($jq(e).attr("data-id"));
});
const initPeriodici = () => {
        getShopId((t) => {
            if (t.success) {
                const e = t.data.result.data.id;
                getShopDiscounts(e, freeChoiceIds, (t) => {
                    if (($(".custom-loading").show(), t.success)) {
                        const a = [];
                        var e = [];
                        (resultFreeChoice = t.data.items),
                            t.data.items.forEach(function (t, o) {
                                (e = t.frequency),
                                    (o += 1),
                                    -1 == a.findIndex((e) => e == t.frequency) &&
                                        ($(".btn-frequency").append(`<input class="opt-btn period" type='radio' name="fr-" id="fr-${o}" value="${e}" onchange="changePeriodiy(event)"> <label class="opt-label" for="fr-${o}">${e}</label>`),
                                        a.push(t.frequency));
                            });
                    } else console.log(t), console.log("Erro ao obter os Descontos freechoice.");
                    $(".custom-loading").hide();
                });
            } else console.log(t), console.log("Erro ao obter o shopID");
        }),
            setProgressBarMax($(".qty-select").eq(0).attr("data-qty"));
    },
    removePeriod = (t) => {
        t.preventDefault(), $(".custom-loading").show();
        const e = $(t.target).attr("data-period"),
            a = $(`[data-periodicidade="${e}"]`);
        let o = "";
        a.each((t, e) => {
            const a = $(e).attr("data-item-key");
            o += 0 == t ? `updates[${a}]=0` : `&updates[${a}]=0`;
        }),
            console.log(o),
            jQuery.post(window.Shopify.routes.root + "cart/update.js", o).done(() => {
                window.location.reload(), $(".custom-loading").hide();
            });
    },
    removeKit = (t) => {
        t.preventDefault(), $(".custom-loading").show();
        const e = $(t.target).attr("data-group"),
            a = $(`[data-kit="${e}"]`);
        let o = "";
        a.each((t, e) => {
            const a = $(e).attr("data-item-key");
            o += 0 == t ? `updates[${a}]=0` : `&updates[${a}]=0`;
        }),
            console.log(o),
            jQuery.post(window.Shopify.routes.root + "cart/update.js", o).done(() => {
                window.location.reload(), $(".custom-loading").hide();
            });
    },
    initCustomCart = () => {
        const t = $("[data-periodicidade]");
        if (t[0]) {
            let e = "";
            const a = [];
            t.each((t, o) => {
                const i = $(o).attr("data-periodicidade"),
                    s = $(o).attr("data-qty");
                a.push($(o).attr("data-item-id")),
                    e != i
                        ? ((e = i),
                          $(o)
                              .before(
                                  `\n                    <li class="item-period-title">\n                        <span class="period-title">\n                            <strong>Periodicidade:</strong> ${i}<br>\n                            <strong>Quantidade Total:</strong> ${s}\n                        </span>\n                        <button type="button" data-period="${i}" onclick="removePeriod(event)">Remover Pack</button>\n                    </li>\n                `
                              )
                              .addClass("item-period"))
                        : $(o).addClass("item-period");
            }),
                getShopId((e) => {
                    if (e.success) {
                        const o = e.data.result.data.id;
                        getShopDiscounts(o, a, (e) => {
                            if (($(".custom-loading").show(), e.success)) {
                                const a = e.data.items;
                                let o = 0;
                                t.each((t, e) => {
                                    const i = $(e).attr("data-item-id"),
                                        s = $(e).attr("data-periodicidade"),
                                        r = a.find((t) => t.variantId == i && t.frequency == s),
                                        n = $(e).find("[data-item-price]"),
                                        c = parseInt(n.attr("data-item-price")),
                                        d = parseInt($(e).find("[data-qty-item]").attr("data-qty-item")),
                                        l = $(e).find("[data-total-line]"),
                                        u = parseInt(l.attr("data-total-line"));
                                    let p = 0;
                                    if (r) {
                                        (p = "Value" == r.discountType ? c - 100 * r.valueDiscount : "Percent" == r.discountType ? c - (r.valueDiscount * c) / 100 : c),
                                            n.find(".product-price__compare")[0] && n.find(".product-price__compare").remove();
                                        let t = p * d;
                                        (o += u - t),
                                            $(n).html(
                                                `\n                                    <div class="product-price__compare theme-money">${theme.Shopify.formatMoney(
                                                    c,
                                                    theme.moneyFormat
                                                )}</div>\n                                    <div class="product-price__reduced theme-money">${theme.Shopify.formatMoney(p, theme.moneyFormat)}</div>\n                                `
                                            ),
                                            $(l).html(
                                                `\n                                    <div class="product-price__compare theme-money">${theme.Shopify.formatMoney(
                                                    u,
                                                    theme.moneyFormat
                                                )}</div>\n                                    <div class="product-price__reduced theme-money">${theme.Shopify.formatMoney(t, theme.moneyFormat)}</div>\n                                `
                                            );
                                    }
                                }),
                                    console.log("total dif discounts", o);
                                const i = $("[data-total-cart]"),
                                    s = parseInt(i.attr("data-total-cart"));
                                let r = s - o;
                                $(i).html(
                                    `\n                            <div class="product-price__compare theme-money">${theme.Shopify.formatMoney(
                                        s,
                                        theme.moneyFormat
                                    )}</div>\n                            <div class="product-price__reduced theme-money">${theme.Shopify.formatMoney(r, theme.moneyFormat)}</div>\n                        `
                                );
                            } else console.log(e), console.log("Erro ao obter os Descontos freechoice.");
                            $(".custom-loading").hide();
                        });
                    } else console.log(e), console.log("Erro ao obter o shopID");
                });
        }
    },
    initKitCustomCart = () => {
        const t = $("[data-kit]");
        if (t[0]) {
            let e = "";
            const a = [];
            t.each((t, o) => {
                const i = $(o).attr("data-kit"),
                    s = $(o).attr("data-qty");
                a.push($(o).attr("data-item-id")),
                    e != i
                        ? ((e = i),
                          $(o)
                              .before(
                                  `\n                    <li class="item-kit-title">\n                        <span class="kit-title">\n                            <strong>Z2 Pack</strong><br>\n                            <strong>Quantidade Total:</strong> ${s}\n                        </span>\n                        <button type="button" data-group="${i}" onclick="removeKit(event)">Remover Pack</button>\n                    </li>\n                `
                              )
                              .addClass("item-kit"))
                        : $(o).addClass("item-kit");
            });
        }
    },
    intervalJquery = setInterval(() => {
        "function" == typeof $ &&
            (clearInterval(intervalJquery),
            setTimeout(() => {
                $(".custom-loading").hide();
            }, 100),
            window.location.href.indexOf("/products") > -1 &&
                $(".form-freechoice")[0] &&
                (getShopId((t) => {
                    if (t.success) {
                        const e = t.data.result.data.id;
                        getShopDiscounts(e, freeChoiceIds, (t) => {
                            if (($(".custom-loading").show(), t.success)) {
                                const a = [];
                                var e = [];
                                (resultFreeChoice = t.data.items),
                                    t.data.items.forEach(function (t, o) {
                                        (e = t.frequency),
                                            (o += 1),
                                            -1 == a.findIndex((e) => e == t.frequency) &&
                                                ($(".btn-frequency").append(
                                                    `<input class="opt-btn period" type='radio' name="fr-" id="fr-${o}" value="${e}" onchange="changePeriodiy(event)"> <label class="opt-label" for="fr-${o}">${e}</label>`
                                                ),
                                                a.push(t.frequency));
                                    });
                            } else console.log(t), console.log("Erro ao obter os Descontos freechoice.");
                            $(".custom-loading").hide();
                        });
                    } else console.log(t), console.log("Erro ao obter o shopID");
                }),
                setProgressBarMax($(".qty-select").eq(0).attr("data-qty"))),
            window.location.href.indexOf("/cart") > -1 && (initCustomCart(), initKitCustomCart()));
    }, 100);
function limitMessage() {
    Swal.fire({ icon: "info", title: "Opss!", text: "Limite de produtos excedido na assinatura" });
}
function QtdSache() {
    $(".js-options").on("click", function () {
        resetBar(),
            $(this).each(function () {
                $(this).find(".opt-labels").addClass("bg-color"), console.log(this);
                var t = $(this).attr("data-qty");
                0 != parseInt(t) && setProgressBarMax(t);
            });
    });
}
const checkPeriodQuant = () => !(!$("input.period:checked")[0] || !$("input.qty-select:checked")[0]),
    resetBar = () => {
        $("#myBar, .qtd-progress, .quanti").val(0);
        let t = $(".qty-select:checked") ? $(".qty-select:checked").data("data-qty") : $(".qty-select").eq(0).attr("data-qty");
        (countItems = 0), setProgressBarMax(t), setKitPrice(), setKitCustom();
    },
    setBarSize = (t) => {
        $("#myBar, .qtd-progress").val(t),
            parseInt($(".qtd-progress").val()) == parseInt($(".progress-bar").attr("max"))
                ? ($(".addKitProducts").addClass("completed"), $(".kit").addClass("completed"))
                : ($(".addKitProducts").removeClass("completed"), $(".kit").removeClass("completed"));
    },
    setProgressBarMax = (t) => {
        $(".value-qtd").html(t), $("#myBar").attr("max", t);
    },
    resetItems = () => {
        $("[data-periodici]").each((t, e) => {
            $(e).show(), $(e).find(".quanti").val(0).prop("disabled", !1);
        });
    },
    changePeriodiy = (t) => {
        resetBar();
        const e = $(t.target),
            a = e.val();
        resultFreeChoice.filter((t) => t.frequency == e.val()).length > 0 &&
            ($("[data-periodici]").each((t, e) => {
                $(e).show(), $(e).find(".quanti").val(0).prop("disabled", !1);
            }),
            $("[data-periodici]").each((t, e) => {
                -1 == $(e).attr("data-periodici").indexOf(a) && ($(e).hide(), $(e).find(".quanti").val(0).prop("disabled", !0));
            }));
    },
    setKitPrice = () => {
        const t = $("[data-periodici]"),
            e = $(".period:checked").val();
        let a = 0;
        t.each((t, o) => {
            const i = parseInt($(o).attr("data-price")),
                s = $(o).find(".quanti");
            if (!$(s).prop("disabled") && $(s).val() > 0) {
                parseInt($(s).val());
                const t = $(o).attr("data-id"),
                    r = resultFreeChoice.find((a) => a.frequency == e && a.variantId == t);
                let n = 0;
                (n = r ? ("Value" == r.discountType ? i - 100 * r.valueDiscount : "Percent" == r.discountType ? i - (r.valueDiscount * i) / 100 : i) : i), (a += n * parseInt($(s).val()));
            }
        }),
            $(".freeChoicePrice").html(theme.Shopify.formatMoney(a, theme.moneyFormat)),
            0 == a ? $(".freeChoicePrice").hide() : $(".freeChoicePrice").show();
    },
    setKitCustom = () => {
        const t = $("[data-id]");
        let e = 0;
        t.each((t, a) => {
            const o = parseInt($(a).attr("data-price")),
                i = $(a).find(".quanti");
            if (!$(i).prop("disabled") && $(i).val() > 0) {
                parseInt($(i).val());
                const t = $(a).attr("data-id"),
                    s = resultFreeChoice.find((e) => e.variantId == t);
                let r = 0;
                (r = s ? ("Value" == s.discountType ? o - 100 * s.valueDiscount : "Percent" == s.discountType ? o - (s.valueDiscount * o) / 100 : o) : o), (e += r * parseInt($(i).val()));
            }
        });
    };
let countItems = 0;
function get_value_qtd(t, e) {
    if ($("input.period:checked")[0] && $("input.qty-select:checked")[0]) {
        $(".quanti");
        const a = $(`.quanti[data-id="${e}"]`),
            o = parseInt($("#myBar").attr("max")),
            i = parseInt(a.val());
        ((t > 0 && countItems < o) || (t < 0 && countItems > 0 && a.val() > 0)) && (a.val(i + t), (countItems += t)), setBarSize(countItems), setKitPrice();
    } else Swal.fire({ icon: "info", title: "Opss!", text: "Selecione a periodicidade e a quantidade" });
}

function get_custom_value_qtd(t, e, a) {
    $(".quanti");
    const o = $(`.quanti[data-id="${e}"]`),
        i = parseInt($("#myBar").attr("max"));
    var s = $(a.target).closest(".content-custom[data-type]").attr("data-type"),
        r = $(`.content-itens li[data-type=${s}]`),
        n = r.find(".itens"),
        c = parseInt(r.attr("data-current")),
        d = parseInt(r.attr("data-qty")),
        l = $(`.content-custom[data-type=${s}] #plus`);
    const u = parseInt(o.val());
    if ((t > 0 && countItems < i) || (t < 0 && countItems > 0 && o.val() > 0)) {
        var p = c + t;
        (c < d || t < 0) && (r.attr("data-current", p), o.val(u + t), (countItems += t)), p >= d ? (l.attr("disable", !0), n.addClass("completed")) : (l.attr("disable", !1), n.removeClass("completed"));
    }
    setBarSize(countItems), setKitCustom();
}

function get_calculadora_value_qtd(t, e, a) {
    $(".quanti");
    const o = $(`.quanti[data-id="${e}"]`)
    
    var s = $(a.target).closest(".content-custom[data-type]").attr("data-type"),
        r = $(`.content-itens li[data-type=${s}]`),
        n = r.find(".itens"),
        c = parseInt(r.attr("data-current")),
        d = parseInt(r.attr("data-qty")),
        l = $(`.content-custom[data-type=${s}] #plus`);
        
    const u = parseInt(o.val());

    if ((t > 0) || (t < 0 && o.val() > 0)){
      // Remove limit checks to allow any value
      var p = c + t; // Calculate new current value without limits
      r.attr("data-current", p); // Update data-current regardless of limits
      o.val(u + t); // Update quantity directly
      countItems += t; // Increment countItems without any limit checks
  
      // Update completion status based on new current value
      p >= d ? (l.attr("disable", !0), n.addClass("completed")) : (l.attr("disable", !1), n.removeClass("completed"));
    }
  
    setBarSize(countItems); // Update the progress bar size
    setKitCustom(); // Update kit customizations
}

"undefined" == typeof $ && console.error("jQuery is not loaded"),
    $(".addKitProducts").on("click", function (t) {
        t.preventDefault(), $(".custom-loading").show();
        var e = parseInt($(".value-qtd").text()),
            a = 0,
            o = [],
            i = { kit: !0, "Quantidade kit": e };
        return (
            $(".quanti").each(function (t) {
                if ($(this).val() > 0 && !$(this).prop("disabled")) {
                    var e = $(this).attr("data-id"),
                        s = $(this).val();
                    (qtdTotal = parseInt(s)), (a += qtdTotal), o.push({ quantity: parseInt(s), id: parseInt(e), properties: i });
                }
            }),
            a == e
                ? $.getJSON("/cart.js", (t) => {
                      $.ajax({
                          type: "POST",
                          url: "/cart/add.js",
                          dataType: "json",
                          data: { items: o },
                          success: function (t) {
                              console.log(t), (window.location.href = "/cart"), $(".custom-loading").hide();
                          },
                          error: function (t) {
                              Swal.fire(t.responseJSON.description), $(".custom-loading").hide();
                          },
                      });
                  })
                : ($(".custom-loading").hide(), Swal.fire({ icon: "error", title: "Opss!", text: `Este Kit exige que tenha ${e} produtos` })),
            !1
        );
    }),
    $(".addProducts").on("click", function (t) {
        t.preventDefault(), $(".custom-loading").show();
        var e = parseInt($(".value-qtd").text()),
            a = 0;
        const o = $(".period:checked").val();
        var i = [],
            s = { Freechoice: !0, Periodicidade: $(".period:checked").val(), "Quantidade Assinatura": $(".qty-select:checked").val() };
        return (
            $(".quanti").each(function (t) {
                if ($(this).val() > 0 && !$(this).prop("disabled")) {
                    var e = $(this).attr("data-id"),
                        o = $(this).val();
                    (qtdTotal = parseInt(o)), (a += qtdTotal), i.push({ quantity: parseInt(o), id: parseInt(e), properties: s });
                }
            }),
            a == e
                ? $.getJSON("/cart.js", (t) => {
                      let e = !1;
                      $.each(t.items, (t, a) => {
                          a.properties && a.properties.Periodicidade == o && (Swal.fire({ icon: "info", title: "Opss!", text: `Você já possui itens com a periodicidade ${o} em seu carrinho!` }), (e = !0), $(".custom-loading").hide());
                      }),
                          e ||
                              $.ajax({
                                  type: "POST",
                                  url: "/cart/add.js",
                                  dataType: "json",
                                  data: { items: i },
                                  success: function (t) {
                                      console.log(t), (window.location.href = "/cart"), $(".custom-loading").hide();
                                  },
                                  error: function (t) {
                                      Swal.fire(t.responseJSON.description), $(".custom-loading").hide();
                                  },
                              });
                  })
                : ($(".custom-loading").hide(), Swal.fire({ icon: "error", title: "Opss!", text: `Esta assinatura exige que tenha ${e} produtos` })),
            !1
        );
    }),
    QtdSache(),
    $(function () {
        var t = 0;
        $(".content-itens .text-value").each(function (e, a) {
            var o = parseInt($(this).attr("data-qty")) || 0;
            t += o;
        }),
            $("#myBar").attr("max", t),
            $(".value-qtd").text(t),
            $("#content-abas-itens .content.opt1").hide(),
            $(".itens").on("click", function () {
                $(".form-kit .bar").show(), $(".itens").removeClass("active"), $(this).addClass("active");
                var t = $(this).parent().index() + 1;
                return $("#content-abas-itens .content").hide(), $(`#content-abas-itens .content.opt${t}`).css("display", "flex"), !1;
            });
        var e = setInterval(function () {
            "complete" === document.readyState &&
                ($(".tooltip").length > 0 &&
                    ($(".tooltip").parent().addClass("active"),
                    setTimeout(() => {
                        $(".info.active").removeClass("active");
                    }, 1e3)),
                clearInterval(e));
        }, 100);
    });
$(".addCalculadoraProducts").on("click", function (t) {
    t.preventDefault();
    $(".custom-loading").show();

    var e = parseInt($(".value-qtd").text()),
        a = 0,
        o = [],
        i = { kit: true, "Quantidade kit": e };

    // Iterate over each quantity input
    $(".quanti").each(function () {
        if ($(this).val() > 0 && !$(this).prop("disabled")) {
            var id = $(this).attr("data-id"),
                quantity = $(this).val();
            var qtdTotal = parseInt(quantity); // Declare qtdTotal properly
            a += qtdTotal;
            o.push({ quantity: qtdTotal, id: parseInt(id), properties: i });
        }
    });

    // Check if total selected quantity matches required quantity
    $.getJSON("/cart.js", function () {
      $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: { items: o },
          success: function (response) {
              console.log(response);
              window.location.href = "/cart";
              $(".custom-loading").hide();
          },
          error: function (error) {
              Swal.fire(error.responseJSON.description);
              $(".custom-loading").hide();
          },
      });
  });

    return false; // Prevent default action
});